import formatDateStringNoTimezone from 'syf-js-utilities/formats/formatDateStringNoTimezone';
import { differenceInCalendarDays, parse } from 'date-fns';
import { STATUS, TYPE } from '../const/activity';
export var DATE_FORMAT_YYYYMMDD = 'yyyy-MM-dd';
export var numberOfDaysToDueDate = function (paymentDate) {
    if (!paymentDate)
        return;
    var calendarDueDate = parse(paymentDate, DATE_FORMAT_YYYYMMDD, new Date());
    return differenceInCalendarDays(calendarDueDate, new Date());
};
export var getNumberOfDaysToScheduledPayment = function (scheduledActivity) {
    var postedDate = scheduledActivity === null || scheduledActivity === void 0 ? void 0 : scheduledActivity.postedDate;
    return numberOfDaysToDueDate(formatDateStringNoTimezone(postedDate));
};
export var getNumberOfDaysToAutopay = function (nextDueDate) {
    return numberOfDaysToDueDate(formatDateStringNoTimezone(nextDueDate));
};
var getOneTimeScheduledActivity = function (activities) {
    return activities.filter(function (activity) {
        var numberOfDaysToScheduledDate = getNumberOfDaysToScheduledPayment(activity);
        return (activity.type === TYPE.payment &&
            activity.paymentType === 'ONE_TIME_PAYMENT' &&
            activity.status === STATUS.pending &&
            numberOfDaysToScheduledDate >= 0);
    });
};
export var getScheduledActivities = function (activity) {
    var oneTimeScheduledActivities = getOneTimeScheduledActivity(activity);
    return oneTimeScheduledActivities === null || oneTimeScheduledActivities === void 0 ? void 0 : oneTimeScheduledActivities.slice().sort(function (firstActivity, secondActivity) {
        var firstItem = getNumberOfDaysToScheduledPayment(firstActivity);
        var secondItem = getNumberOfDaysToScheduledPayment(secondActivity);
        return firstItem - secondItem;
    });
};
export var getProcessingActivities = function (activity) {
    var processingActivities = activity.filter(function (processingActivity) {
        return processingActivity.type === TYPE.payment &&
            processingActivity.status === STATUS.processing;
    });
    return processingActivities === null || processingActivities === void 0 ? void 0 : processingActivities.slice().sort(function (firstActivity, secondActivity) {
        return new Date(secondActivity.createdDate).getTime() -
            new Date(firstActivity.createdDate).getTime();
    });
};
